import React, { useState, useEffect } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import FileDownloader from "../../../../components/UI/Button/FileDownloader";

const AndamentoAlteracaoExecutorDetalhamento = ({ data, anexos, atualizaAnexos }) => {
  const [anexosAndamento, setAnexosAndamento] = useState([]);

  useEffect(() => {
    if (data && anexos.length) {
      let listaAnexos = [];
      anexos.forEach((element) => {
        if (element.sequencialAndamento === data.sqAndamento && element.sequencialAtividade === data.sqAtividade) {
          listaAnexos = [...listaAnexos, element];
        }
      });
      setAnexosAndamento(listaAnexos);
    }
  }, [anexos, atualizaAnexos, data]);

  if (!anexosAndamento.length) {
    return (
      <div className="m-2">
        <span className="m-0 font-weight-bold text-primary flex-grow-1 px-3">Nenhum anexo para este andamento</span>
      </div>
    );
  }

  return (
    <div className="text-left m-4">
      <h5>Anexos</h5>
      <ul className="list-group">
        {anexosAndamento.map((item) => (
          <li className="list-group-item" key={item.descricao}>
            <AiOutlineCheck className="text-success" />
            &nbsp;
            {item.descricao ? `${item.nomeArquivo} -> ${item.descricao}` : item.nomeArquivo}
            <FileDownloader
              binario={item.conteudoBinario}
              nomeArquivo={item.nomeArquivo}
              tooltip={item.descricao ? `${item.nomeArquivo} -> ${item.descricao}` : item.nomeArquivo}
              className="ml-2"
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AndamentoAlteracaoExecutorDetalhamento;
